import axiosInstance from "../utils/axiosInstance";
import { URLS } from "../utils/baseUrls";

const fetchAllGroups = () => {
  return axiosInstance.get(`${URLS.groups}/`);
};

const fetchGroup = (id) => {
  return axiosInstance.get(`${URLS.groups}/${id}/`);
};

const createGroup = (data) => {
  return axiosInstance.post(`${URLS.groups}/`, data);
};

const updateGroup = (id, data) => {
  return axiosInstance.patch(`${URLS.groups}/${id}/`, data);
};

const deleteGroup = (id) => {
  return axiosInstance.delete(`${URLS.groups}/${id}/`);
};

const fetchGroupMembers = (id) => {
  return axiosInstance.get(`${URLS.groups}/${id}/members/`);
};

const removeGroupMember = (id, userId) => {
  return axiosInstance.delete(`${URLS.groups}/${id}/members/${userId}/`);
};

const sendGroupInvitation = (
  id,
  { invitedUserId, invitedEmail, message, requestedScopedPermissionIds, requestedResourcePermissionIds }
) => {
  return axiosInstance.post(`${URLS.groups}/${id}/invitations/send/`, {
    invited_user_id: invitedUserId,
    invited_email: invitedEmail,
    message,
    requested_scoped_permission_ids: requestedScopedPermissionIds,
    requested_resource_permission_ids: requestedResourcePermissionIds,
  });
};

const fetchGroupInvitations = (id) => {
  return axiosInstance.get(`${URLS.groups}/${id}/invitations/`);
};

const revokeGroupInvitation = (id, invitationId) => {
  return axiosInstance.delete(
    `${URLS.groups}/${id}/invitations/${invitationId}/revoke/`
  );
};

const fetchMyGroupInvitations = () => {
  return axiosInstance.get(`${URLS.groups}/invitations/my/`);
};

const respondToGroupInvitation = (
  token,
  action,
  { fieldSharingEnabled, fieldIds, shareActionsEnabled, shareProductionDataEnabled } = {}
) => {
  return axiosInstance.post(`${URLS.groups}/invitations/${token}/${action}/`, {
    field_sharing_enabled: fieldSharingEnabled,
    field_ids: fieldIds,
    share_actions_enabled: shareActionsEnabled,
    share_production_data_enabled: shareProductionDataEnabled,
  });
};

const fetchGroupMemberPermissions = (id) => {
  return axiosInstance.get(`${URLS.groups}/${id}/permissions/`);
};

const grantGroupPermissions = (
  id,
  { userId, scopedPermissionIds, resourcePermissionIds }
) => {
  return axiosInstance.post(`${URLS.groups}/${id}/permissions/grant/`, {
    user_id: userId,
    scoped_permission_ids: scopedPermissionIds,
    resource_permission_ids: resourcePermissionIds,
  });
};

const assignGroupAdmin = (id, userId) => {
  return axiosInstance.post(`${URLS.groups}/${id}/assign-admin/`, {
    user_id: userId,
  });
};

const searchGroups = (query) => {
  return axiosInstance.get(`${URLS.groups}/search/`, { params: { q: query } });
};

const fetchGroupJoinRequests = (id) => {
  return axiosInstance.get(`${URLS.groups}/${id}/join-requests/`);
};

const sendGroupJoinRequest = (
  id,
  { message, fieldSharingEnabled, fieldIds, shareActionsEnabled, shareProductionDataEnabled } = {}
) => {
  return axiosInstance.post(`${URLS.groups}/${id}/join-requests/`, {
    message,
    field_sharing_enabled: fieldSharingEnabled,
    field_ids: fieldIds,
    share_actions_enabled: shareActionsEnabled,
    share_production_data_enabled: shareProductionDataEnabled,
  });
};

const fetchGroupMemberFieldSharing = (id) => {
  return axiosInstance.get(`${URLS.groups}/${id}/members/me/field-sharing/`);
};

const updateGroupMemberFieldSharing = (
  id,
  { fieldSharingEnabled, fieldIds, shareActionsEnabled, shareProductionDataEnabled }
) => {
  return axiosInstance.put(`${URLS.groups}/${id}/members/me/field-sharing/`, {
    field_sharing_enabled: fieldSharingEnabled,
    field_ids: fieldIds,
    share_actions_enabled: shareActionsEnabled,
    share_production_data_enabled: shareProductionDataEnabled,
  });
};

const fetchMyGroupJoinRequests = () => {
  return axiosInstance.get(`${URLS.groups}/join-requests/my/`);
};

const respondToGroupJoinRequest = (groupId, requestId, action) => {
  return axiosInstance.post(`${URLS.groups}/${groupId}/join-requests/${requestId}/${action}/`);
};

export const groupsApi = {
  fetchAll: fetchAllGroups,
  fetchOne: fetchGroup,
  create: createGroup,
  update: updateGroup,
  deleteOne: deleteGroup,
  fetchMembers: fetchGroupMembers,
  removeMember: removeGroupMember,
  sendInvitation: sendGroupInvitation,
  fetchInvitations: fetchGroupInvitations,
  revokeInvitation: revokeGroupInvitation,
  fetchMyInvitations: fetchMyGroupInvitations,
  respondToInvitation: respondToGroupInvitation,
  fetchMemberPermissions: fetchGroupMemberPermissions,
  grantPermissions: grantGroupPermissions,
  assignAdmin: assignGroupAdmin,
  search: searchGroups,
  fetchJoinRequests: fetchGroupJoinRequests,
  sendJoinRequest: sendGroupJoinRequest,
  fetchMyJoinRequests: fetchMyGroupJoinRequests,
  respondToJoinRequest: respondToGroupJoinRequest,
  fetchFieldSharing: fetchGroupMemberFieldSharing,
  updateFieldSharing: updateGroupMemberFieldSharing,
};
